import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logger from 'src/utils/logger';
import { beginSession } from 'src/services/session';

function TokenLogin() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      logger.warn('No token provided in token-login URL');
      setError(true);
      return;
    }

    // Same invariant as the password login: a new token starts on a clean
    // client state. A token link may well belong to a different user than the
    // one whose cache is still lying around.
    beginSession(token);
    navigate('/dashboard', { replace: true });
  }, []);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-16">
        <span className="typo-text-16--bold">{t('auth.token_login_failed')}</span>
        <span className="typo-text-14 text-faded">{t('auth.token_login_failed_description')}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen">
      <span className="typo-text-16">{t('auth.token_login_loading')}</span>
    </div>
  );
}

export default TokenLogin;
